import { useMutation, useQuery } from '@tanstack/react-query';
import { CourseService } from '@/services';
import type { ChapterNote } from '@/types';

export function useChapterNote(chapterId: string, enabled: boolean) {
  return useQuery({
    queryKey: ['chapterNotes', 'unit', chapterId],
    queryFn: () => CourseService.getChapterNote(chapterId),
    enabled,
    gcTime: 0,
    staleTime: 0,
    refetchOnMount: 'always',
    refetchOnReconnect: 'always',
  });
}

export function useUpdateChapterNote() {
  return useMutation({
    mutationFn: (newChapterNote: ChapterNote) => CourseService.upsertChapterNote(newChapterNote),
  });
}
